import React, { forwardRef } from 'react';
import { useButton } from '@react-aria/button';
import { useObjectRef } from '../../hooks/useObjectRef';
import { StyledIconButton } from './styled';
export const IconButton = forwardRef(function IconButton(props, externalRef) {
    const { children, ...rest } = props;
    const ref = useObjectRef(externalRef);
    const { buttonProps } = useButton(props, ref);
    return (React.createElement(StyledIconButton, { ref: ref, ...buttonProps, ...rest }, children));
});
